import { useContext } from 'react';

import { ConfigContext } from '@/providers';

export const useConfig = () => {
  const config = useContext(ConfigContext);

  return config;
};
